import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { strings } from '../../resources/strings';
import { OrderImportStatusCodeEnum } from '../../enums/OrderImportStatusCodeEnum';
import { OrderImportHeader } from '../../models/OrderImportHeader';
import ServicesContext from '../../contexts/ServicesContext';
import { FlexColumnListHeader } from '../../common-components/Layout/FlexColumnList/FlexColumnListHeader';
import { IFlexColumnListItem } from '../../common-components/Layout/FlexColumnList/IFlexColumnListItem';
import { FlexColumnListRow } from '../../common-components/Layout/FlexColumnList/FlexColumnListRow';
import { ListContainer } from './styles';

const columns: IFlexColumnListItem[] = [
  {
    field: 'id',
    title: 'ID',
    width: '70px'
  },
  {
    field: 'createdAt',
    title: 'Data',
    width: '100px',
    type: 'date'
  },
  {
    field: 'importFinishedAt',
    title: 'Importação',
    width: '100px',
    type: 'date'
  },
  {
    field: 'data',
    title: 'Dados',
    width: 'calc(100% - 30% - 370px)',
    maxHeight: '100px'
  },
  {
    field: 'statusCode',
    title: 'Status',
    width: '100px',
    align: 'center',
    mapping: [
      { key: OrderImportStatusCodeEnum.Error, value: 'Erro' },
      { key: OrderImportStatusCodeEnum.PreviouslyImportedOrder, value: 'Pedido já importado' },
      { key: OrderImportStatusCodeEnum.Success, value: 'Sucesso' },
    ]
  },
  {
    field: 'errorMessage',
    title: 'Erro',
    width: 'calc(30%)',
    maxHeight: '100px'
  }
];

interface ModalAmaroOrderImportDetailsProps {
  orderImportId?: number;
  close: () => void;
}

const ModalAmaroOrderImportDetails: React.FC<ModalAmaroOrderImportDetailsProps> = ({
  orderImportId,
  close
}) => {

  const [orderImportHeader, setOrderImportHeader] = React.useState<OrderImportHeader | null | undefined>(null);
  const [loading, setLoading] = React.useState<boolean>(true);

  const {
    alertService,
    getOrderImportService
  } = React.useContext(ServicesContext);

  React.useEffect(() => {
    getOrderImport();
  }, [orderImportId]);

  const memoBody = React.useMemo(() => {
    return (
      <>
        <FlexColumnListHeader
          name='order_import_amaro'
          columns={columns}
        />
        <ListContainer>
          <FlexColumnListRow
            name='order_import_amaro'
            columns={columns}
            values={orderImportHeader?.orderImportItemResults}
          />
        </ListContainer>
      </>
    )
  }, [orderImportHeader]);

  return (
    <Modal
      show={true}
      onHide={() => {
        closeModal();
      }}
      backdrop="static"
      keyboard={false}
      dialogClassName='modal-full-screen'
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Detalhes da Importação de Pedidos Amaro - {orderImportId}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {memoBody}
      </Modal.Body>
    </Modal>
  );

  function closeModal() {
    close();
  }

  function getOrderImport() {
    if (!orderImportId) return;
    getOrderImportService.handle({orderImportId: orderImportId})
      .then(result => {
        setOrderImportHeader(result?.value?.orderImport);
      })
      .catch(() => {
        alertService.warning(strings.OpsSomethingWrongGettingTheData);
      })
      .finally(() => {
        setLoading(false);
      });
  }

}

export { ModalAmaroOrderImportDetails };